/**
 *  @class
 *  @function Cart
 */
class Cart {

  constructor() {
    this.container = document.getElementById('Cart');
    this.setupEventListeners();
    this.observer = null;
    this.initializeStickyBar();
    this.setupGiftEventListeners();
  }
  
  initializeStickyBar() {
    // Page load'da sepet durumunu kontrol et
    setTimeout(() => {
      this.handleCartUpdate();
    }, 100); // DOM'un tamamen yüklenmesini bekle
  }

  onChange(event) {
    if (event.target.type == 'number') {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
      this.saveNotes();
    }
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('CartSpecialInstructions').value
      })
    });
  }
  async setupEventListeners() {
    this.removeProductEvent();
    this.setupClearCartEvent();

    window.addEventListener('hollyWishListAppRemoveFromCart', async () => {
      await checkAndUpdateCartDiscount();
      this.refresh();
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    // Holly Wishlist Remove From Cart
    window.addEventListener('hollyWishListAppRemoveFromCart', () => {
      this.refresh();
    });
    
    window.addEventListener('hp-cart-sync:cart-updated', () => {
      this.refresh();
    });
    // Custom event for clearing cart
    document.addEventListener('cart:clear', (event) => {
      this.clearCart();
    });

    // Cart updated events - sepete ürün eklendiğinde sticky bar'ı kontrol et
    document.addEventListener('cart:updated', () => {
      this.handleCartUpdate();
    });
    
    // Line item change events
    document.addEventListener('line-item:change:end', (event) => {
      this.handleCartUpdate();
    });

    this.setupCouponEventListeners()
    if (!this.container.hasAttribute('data-change-listener-setup')) {
      this.container.setAttribute('data-change-listener-setup', 'true');
      this.container.addEventListener('change', this.debouncedOnChange.bind(this));
    }
  }
  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  displayErrors(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  updateQuantity(line, quantity) {
    this.container.classList.add('cart-disabled');
    if (line) {
      this.container.querySelector(`#CartItem-${line}`).classList.add('loading');
    }
    const checkoutButton = document.getElementById('checkout-button');
    if (checkoutButton) {
      checkoutButton.disabled = true;
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);
        const checkoutButton = document.getElementById('checkout-button');
        const quantityElements = document.querySelectorAll(`.qty-cart-${line}`);
        if (parsedState.errors) {
          quantityElements.forEach((quantityElement) => {
            quantityElement.value = quantityElement.getAttribute('value');
          });

          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          if (checkoutButton) {
            checkoutButton.disabled = false;
          }
          return;
        }

        const sections = this.getSectionsToRender().map((section) => section.section);
        const updatedSections = await checkAndUpdateCartDiscount(sections);

        if (updatedSections) {
          parsedState.sections = updatedSections;
        }

        this.renderContents(parsedState, line, false);

        this.container.classList.remove('cart-disabled');
        if (checkoutButton) {
          checkoutButton.disabled = false;
        }

        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
        
        // Sepet boş kaldıysa sticky bar'ı gizle
        if (parsedState.item_count === 0) {
          const stickyBar = document.getElementById('sticky-checkout-bar');
          if (stickyBar) {
            stickyBar.style.transform = 'translateY(100%)';
          }
          if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
          }
        }
      });
  }
  refresh() {
    this.container.classList.add('cart-disabled');

    let sections = 'main-cart';

    fetch(`${window.location.pathname}/?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, false, true);

        this.container.classList.remove('cart-disabled');
      });
      document.dispatchEvent(new CustomEvent('cart:updated'));
  }
  removeProductEvent() {
    // Event delegation kullanarak duplicate listener sorununu çözüyoruz
    // Container'a tek bir listener ekleyip, event.target ile kontrol ediyoruz
    // Bu sayede DOM yenilendiğinde bile listener çalışmaya devam eder ve duplicate olmaz
    if (!this.container.hasAttribute('data-remove-listener-setup')) {
      this.container.setAttribute('data-remove-listener-setup', 'true');
      this.container.addEventListener('click', (event) => {
        const removeButton = event.target.closest('.remove');
        if (removeButton && removeButton.dataset.index) {
          event.preventDefault();
          this.updateQuantity(removeButton.dataset.index, '0');
        }
      });
    }
  }
  setupClearCartEvent() {
    const clearCartButton = this.container.querySelector('[data-clear-cart-button]');
    if (clearCartButton && !clearCartButton.hasAttribute('data-event-setup')) {
      clearCartButton.setAttribute('data-event-setup', 'true');
      // Alpine.js ile handle ediliyor, burada ekstra bir şey yapmamıza gerek yok
    }
  }
  clearCart() {
    this.container.classList.add('cart-disabled');
    
    fetch(`${theme.routes.cart_clear_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then((response) => {
      return response.text();
    })
    .then(() => {
      this.refresh();
      this.container.classList.remove('cart-disabled');
      
      // Sepet temizlendiğinde sticky bar'ı gizle
      const stickyBar = document.getElementById('sticky-checkout-bar');
      if (stickyBar) {
        stickyBar.style.transform = 'translateY(100%)';
      }
      
      // Observer'ı temizle
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    })
    .catch((error) => {
      console.error('Error clearing cart:', error);
      this.container.classList.remove('cart-disabled');
    });
  }
  renderContents(parsedState, line, refresh) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      if (refresh) {
        if (parsedState[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }
      } else {
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }
      this.setupCouponEventListeners()
      // removeProductEvent() artık gerekli değil - event delegation kullanıyoruz
      this.setupClearCartEvent();
      this.setupGiftEventListeners();

      if (line && this.container.querySelector(`#CartItem-${line}`)) {
        this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
      }
    }));
    
    this.updateStickyTotal();
    
    this.setupStickyCheckoutBar();
  }
  // Holly Coupon

  async handleCoupon(isDeleteRequest = false, value) {
    // Silme işlemi değilse ve zaten bir kod varsa hata göster
    if (!isDeleteRequest && this.appliedCoupons.length >= 1) {
      const errorMessage = window.theme?.strings?.cart?.coupon?.max_one_coupon || 'En fazla 1 adet indirim kodu kullanabilirsiniz.'
      this.showCouponError(errorMessage)
      return
    }
    
    const discountCodes = isDeleteRequest 
      ? this.appliedCoupons.filter(code => code !== value)
      : !this.appliedCoupons.includes(value) ? [...this.appliedCoupons, value] : this.appliedCoupons

    this.sendCouponRequest(discountCodes, value)
  }

  async sendCouponRequest(codeArray, newCode){
    const isDeleteRequest = !codeArray.includes(newCode)

    this.container.classList.add('cart-disabled');

    let currentButton = null
    if(isDeleteRequest){
      currentButton = document.querySelector(`[data-remove-coupon-button][value="${newCode}"]`)
    } else {
      currentButton = document.querySelector('[data-apply-coupon-button]')
    }
    currentButton.lastElementChild.classList.add('hp-loading')
    currentButton.disabled = true

    try {
      const cart = await this.updateDiscountCodes(codeArray)

      if(isDeleteRequest || cart.discount_codes?.find(code => code.code === newCode)?.applicable){
        await checkAndUpdateCartDiscount();
        this.refresh()
        this.appliedCoupons = codeArray
      } else {
        // Shopify uygulanamayan kodu sepette bırakır; önceki kodlara geri al
        await this.updateDiscountCodes(this.appliedCoupons)
        const errorMessage = window.theme?.strings?.cart?.coupon?.error || 'Kupon kodu geçersiz veya uygulanamıyor.'
        this.showCouponError(errorMessage)
      }
    } catch (error) {
      console.warn(error);
      const errorMessage = window.theme?.strings?.cart?.coupon?.error || 'Kupon kodu geçersiz veya uygulanamıyor.'
      this.showCouponError(errorMessage)
    } finally {
      this.container.classList.remove('cart-disabled');
      currentButton?.lastElementChild.classList.remove('hp-loading')
      currentButton.disabled = false
    }
  }
  setupCouponEventListeners(){
    const appliedCouponsList = this.container.querySelector('[data-coupon-list]')?.getAttribute('data-coupon-list')
    this.appliedCoupons = appliedCouponsList?.split(',') || []

    const couponContainer = this.container.querySelector('[data-coupon-container]')
    if(!couponContainer) return
    const couponForm = couponContainer.querySelector('[data-coupon-form]')
    const couponApplyButton = couponForm.querySelector('[data-apply-coupon-button]')
    const couponInput = couponForm.querySelector('input[type="text"]')
    const removeCouponButtons = couponContainer.querySelectorAll('[data-remove-coupon-button]')
    
    couponApplyButton.addEventListener('click', () => {
      if(couponInput.value.length > 0){
        this.handleCoupon(false, couponInput.value)
      }
    })

    couponInput.addEventListener('keydown', (e) =>{
      if(e.code === 'Enter') e.preventDefault()
    })

    removeCouponButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.handleCoupon(true, button.value)
      })
    })
  }
  showCouponError(errorText) {
    const couponError = this.container.querySelector('[data-coupon-error]')
    if (!couponError) return
    
    // Eğer text parametresi verilmişse, içeriği güncelle
    if (errorText) {
      couponError.textContent = errorText
    }
    
    couponError.classList.remove('hp:opacity-0')
    couponError.scrollIntoView({ behavior: 'smooth', block: 'center' })
    setTimeout(() => {
      couponError.classList.add('hp:opacity-0')
    }, 3500)
  }
  async updateDiscountCodes(codes) {
    // Ajax Cart API: virgülle ayrılmış liste sepetteki tüm kodların yerine geçer, boş string hepsini kaldırır
    const response = await fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: codes.join(',') })
    })
    if (!response.ok) throw new Error(`cart/update.js failed: ${response.status}`)
    return response.json()
  }
  
  setupStickyCheckoutBar() {
    const stickyBar = document.getElementById('sticky-checkout-bar');
    const checkoutButton = document.getElementById('checkout-button');
    
    // Sepet boşsa sticky bar'ı gizle
    if (!checkoutButton) {
      if (stickyBar) {
        stickyBar.style.transform = 'translateY(100%)';
      }
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      return;
    }
    
    if (!stickyBar) return;
    
    if (this.observer) {
      this.observer.disconnect();
    }
    
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyBar.style.transform = 'translateY(100%)';
        } else {
          stickyBar.style.transform = 'translateY(0)';
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });
    
    this.observer.observe(checkoutButton);
  }
  
  updateStickyTotal() {
    const stickyTotal = document.querySelector('[data-sticky-total]');
    const mainTotal = document.querySelector('[data-last-amount]');

    if (stickyTotal && mainTotal) {
      stickyTotal.innerHTML = mainTotal.innerHTML;
    }
  }
  
  handleCartUpdate() {
    // Sepet durumunu kontrol et
    const checkoutButton = document.getElementById('checkout-button');
    const stickyBar = document.getElementById('sticky-checkout-bar');
    
    if (!stickyBar) return;
    
    if (checkoutButton) {
      // Sepet dolu - sticky bar'ı aktif et
      this.setupStickyCheckoutBar();
    } else {
      // Sepet boş - sticky bar'ı gizle
      stickyBar.style.transform = 'translateY(100%)';
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  // Holly Gift Package System
  setupGiftEventListeners() {
    // Sayfa yüklendiğinde tüm modal'ları kapat
    const allModals = this.container.querySelectorAll('[id*="gift-checkbox-modal"]');
    allModals.forEach(modal => {
      modal.classList.add('hp:hidden');
    });

    // Hediye checkbox'ları için event listener'lar
    const giftCheckboxes = this.container.querySelectorAll('[data-gift-checkbox-input]');
    const giftModalButtons = this.container.querySelectorAll('[data-gift-checkbox-modal-open]');
    
    giftCheckboxes.forEach(checkbox => {
      if (!checkbox.hasAttribute('data-gift-event-setup')) {
        checkbox.setAttribute('data-gift-event-setup', 'true');
        checkbox.addEventListener('change', (e) => {
          this.handleGiftCheckboxChange(e.target);
        });
      }
    });

    giftModalButtons.forEach(button => {
      if (!button.hasAttribute('data-gift-modal-event-setup')) {
        button.setAttribute('data-gift-modal-event-setup', 'true');
        button.addEventListener('click', (e) => {
          this.openGiftModal(e.target.getAttribute('data-gift-checkbox-modal-open'));
        });
      }
    });

    // Save button'lar için event listener'lar
    const saveButtons = this.container.querySelectorAll('[data-save-gift-modal]');
    saveButtons.forEach(button => {
      if (!button.hasAttribute('data-save-event-setup')) {
        button.setAttribute('data-save-event-setup', 'true');
        button.addEventListener('click', (e) => {
          this.saveGiftModal(e.currentTarget.getAttribute('data-item-id'));
        });
      }
    });
  }

  async handleGiftCheckboxChange(checkbox) {
    // Reset işlemi sırasında event'i yok say
    if (checkbox.hasAttribute('data-resetting')) {
      return;
    }
    
    const itemKey = checkbox.getAttribute('data-line-key');
    const quantity = checkbox.getAttribute('data-quantity');
    const isChecked = checkbox.checked;

    if (isChecked) {
      // Checkbox'ın original durumunu sakla (modal açılmadan önceki durum)
      const originalState = !isChecked; // Şu anda true ise, önceki durumu false'tu
      checkbox.setAttribute('data-original-state', originalState.toString());
      
      // Hediye paketi açıldığında modal'ı aç
      const modalId = checkbox.getAttribute('id').replace('gift-checkbox-', 'gift-checkbox-modal-');
      const itemIdForModal = modalId.replace('gift-checkbox-modal-', '');
      await this.openGiftModal(itemIdForModal);
    } else {
      // Hediye paketi kapatıldığında property'yi kaldır
      await this.updateGiftProperties(itemKey, quantity, false, '');
    }
  }

  async openGiftModal(itemId) {
    const modal = document.getElementById(`gift-checkbox-modal-${itemId}`);
    if (modal) {
      // Modal'daki değerleri properties'lerden güncelle
      await this.populateGiftModalValues(modal, itemId);
      modal.classList.remove('hp:hidden');
      
      // Event listener'ları setup et
      this.setupGiftModalEvents(modal, itemId);
      
      // Body scroll'unu engelle
      document.body.style.overflow = 'hidden';
    }
  }

  async populateGiftModalValues(modal, itemId) {
    const checkbox = document.getElementById(`gift-checkbox-${itemId}`);
    const isCurrentlyGift = checkbox ? checkbox.checked : false;
    
    // Item properties'lerden hediye notu bilgisini al
    const existingNote = await this.getGiftNoteFromProperties(itemId);
    const hasExistingNote = existingNote && existingNote.length > 0;
    
    // Modal elementlerini bul
    const packageCheckbox = modal.querySelector('[data-modal-gift-package]');
    const noteCheckbox = modal.querySelector('[data-modal-gift-note]');
    const noteLabel = modal.querySelector('[data-gift-note-label]');
    const textarea = modal.querySelector('[data-gift-note-textarea]');
    const characterCount = modal.querySelector('[data-character-count]');
    
    // Değerleri set et
    if (packageCheckbox) packageCheckbox.checked = isCurrentlyGift;
    if (noteCheckbox) {
      noteCheckbox.checked = hasExistingNote;
      // Hediye paketi seçili değilse hediye notu checkbox'ı disabled olsun
      noteCheckbox.disabled = !isCurrentlyGift;
    }
    if (noteLabel) {
      // Label görünümünü güncelle
      if (!isCurrentlyGift) {
        noteLabel.classList.add('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
      } else {
        noteLabel.classList.remove('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
      }
    }
    if (textarea) {
      textarea.value = existingNote || '';
      textarea.disabled = !hasExistingNote || !isCurrentlyGift;
    }
    if (characterCount) {
      this.updateCharacterCount(textarea, characterCount);
    }
  }

  setupGiftModalEvents(modal, itemId) {
    // Önceki event'leri temizle
    if (modal.hasAttribute('data-modal-events-setup')) {
      return;
    }
    modal.setAttribute('data-modal-events-setup', 'true');

    const packageCheckbox = modal.querySelector('[data-modal-gift-package]');
    const noteCheckbox = modal.querySelector('[data-modal-gift-note]');
    const noteLabel = modal.querySelector('[data-gift-note-label]');
    const textarea = modal.querySelector('[data-gift-note-textarea]');
    const characterCount = modal.querySelector('[data-character-count]');
    const saveButton = modal.querySelector('[data-save-gift-modal]');

    // Ana checkbox'ın orijinal durumunu al
    const mainCheckbox = document.getElementById(`gift-checkbox-${itemId}`);
    
    // Original state'i data-original-state attribute'inden al
    let originalMainCheckboxState = false;
    if (mainCheckbox && mainCheckbox.hasAttribute('data-original-state')) {
      originalMainCheckboxState = mainCheckbox.getAttribute('data-original-state') === 'true';
    } else {
      originalMainCheckboxState = mainCheckbox ? mainCheckbox.checked : false;
    }

    // Modal açıldığında orijinal değerleri sakla
    const originalValues = {
      packageChecked: packageCheckbox.checked,
      noteChecked: noteCheckbox.checked,
      noteText: textarea.value,
      noteDisabled: noteCheckbox.disabled,
      mainCheckboxChecked: originalMainCheckboxState
    };

    // Package checkbox değiştiğinde
    packageCheckbox.addEventListener('change', () => {
      if (!packageCheckbox.checked) {
        noteCheckbox.checked = false;
        noteCheckbox.disabled = true;
        noteLabel.classList.add('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
        textarea.disabled = true;
        textarea.value = '';
        this.updateCharacterCount(textarea, characterCount);
      } else {
        noteCheckbox.disabled = false;
        noteLabel.classList.remove('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
      }
    });

    // Note checkbox değiştiğinde
    noteCheckbox.addEventListener('change', () => {
      if (noteCheckbox.checked && packageCheckbox.checked) {
        textarea.disabled = false;
        textarea.focus();
      } else {
        textarea.disabled = true;
        if (!packageCheckbox.checked) {
          textarea.value = '';
          this.updateCharacterCount(textarea, characterCount);
        }
      }
    });

    // Textarea karakter sayımı
    textarea.addEventListener('input', () => {
      this.updateCharacterCount(textarea, characterCount);
    });

    // Modal reset fonksiyonu
    const resetModalValues = () => {
      // Ana checkbox'ı orijinal durumuna döndür (event tetiklememek için geçici olarak event'i kaldır)
      if (mainCheckbox) {
        // Event'leri geçici olarak engelle
        mainCheckbox.setAttribute('data-resetting', 'true');
        
        // Checkbox'ı reset et
        mainCheckbox.checked = originalValues.mainCheckboxChecked;
        
        // Event engellemesini kaldır ve original state attribute'ini temizle
        setTimeout(() => {
          mainCheckbox.removeAttribute('data-resetting');
          mainCheckbox.removeAttribute('data-original-state');
        }, 10);
      }
      
      packageCheckbox.checked = originalValues.packageChecked;
      noteCheckbox.checked = originalValues.noteChecked;
      noteCheckbox.disabled = originalValues.noteDisabled;
      
      // Label görünümünü restore et
      if (originalValues.noteDisabled) {
        noteLabel.classList.add('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
      } else {
        noteLabel.classList.remove('hp:opacity-50', 'hp:cursor-not-allowed', 'hp:text-gray-400');
      }
      
      textarea.value = originalValues.noteText;
      textarea.disabled = !originalValues.noteChecked || !originalValues.packageChecked;
      this.updateCharacterCount(textarea, characterCount);
    };

    // Modal close event'i için
    const handleModalClose = () => {
      resetModalValues();
      modal.classList.add('hp:hidden');
      // Body scroll'unu geri aç
      document.body.style.overflow = 'auto';
    };

    // Modal dışına tıklayınca kapat ve reset et
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        handleModalClose();
      }
    });

    // X butonu click event'i
    const closeButton = modal.querySelector('[data-modal-close]');
    if (closeButton) {
      closeButton.addEventListener('click', handleModalClose);
    }

    // Modal'ın mevcut close event'lerini override et
    modal.setAttribute('data-modal-close-handler', 'true');
    modal.handleModalClose = handleModalClose;
  }

  updateCharacterCount(textarea, countElement) {
    const remaining = 144 - textarea.value.length;
    countElement.textContent = `Kalan karakter limiti: ${remaining}`;
    countElement.className = remaining < 20 ? 'hp:text-xs hp:text-red-500' : 'hp:text-xs hp:text-gray-500';
  }

  async saveGiftModal(itemId) {
    const modal = document.getElementById(`gift-checkbox-modal-${itemId}`);
    const packageCheckbox = modal.querySelector('[data-modal-gift-package]');
    const noteCheckbox = modal.querySelector('[data-modal-gift-note]');
    const textarea = modal.querySelector('[data-gift-note-textarea]');
    const button = modal.querySelector('[data-save-gift-modal]');
    const buttonText = button.querySelector('[data-button-text]');
    const buttonLoading = button.querySelector('[data-button-loading]');
    
    const isGiftPackage = packageCheckbox.checked;
    const giftNote = noteCheckbox.checked ? textarea.value : '';
    
    // Loading state'ini başlat
    button.disabled = true;
    buttonText.classList.add('hp:opacity-0');
    buttonLoading.classList.remove('hp:opacity-0');
    buttonLoading.classList.add('hp:opacity-100');
    
    try {
      // Ana checkbox'ı güncelle
      const mainCheckbox = document.getElementById(`gift-checkbox-${itemId}`);
      if (mainCheckbox) {
        mainCheckbox.checked = isGiftPackage;
        
        // Original state attribute'ini temizle (değişiklikler kaydedildi)
        mainCheckbox.removeAttribute('data-original-state');
        
        // Line index ve key bilgilerini al
        const itemKey = mainCheckbox.getAttribute('data-line-key');
        const quantity = mainCheckbox.getAttribute('data-quantity');
        
        // Cart properties'i güncelle
        await this.updateGiftProperties(itemKey, quantity, isGiftPackage, giftNote);
      }
      
      // Modal'ı kapat
      modal.classList.add('hp:hidden');
      // Body scroll'unu geri aç
      document.body.style.overflow = 'auto';
    } catch (error) {
      console.error('Error saving gift modal:', error);
    } finally {
      // Loading state'ini bitir
      button.disabled = false;
      buttonText.classList.remove('hp:opacity-0');
      buttonLoading.classList.add('hp:opacity-0');
      buttonLoading.classList.remove('hp:opacity-100');
    }
  }

  async getGiftNoteFromProperties(itemId) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Item ID'si "product-id-item-key" formatında, bunu parse et
      const parts = itemId.split('-');
      const itemKey = parts[parts.length - 1]; // Son part line index
      
      // Cart items'dan ilgili item'ı bul (line index 1-based)
      const item = cart.items[itemKey - 1];
      
      if (item && item.properties && item.properties['_line_item_gift_note']) {
        return item.properties['_line_item_gift_note'];
      }
      
      return '';
    } catch (error) {
      console.error('Error getting gift note from properties:', error);
      return '';
    }
  }

  async updateGiftProperties(itemKey, quantity, isGift, giftNote = '') {
    this.container.classList.add('cart-disabled');
    
    let properties = {};
    
    if (isGift) {
      properties['_is_line_item_gift'] = 'true';
      if (giftNote) {
        properties['_line_item_gift_note'] = giftNote;
      }
    } else {
      properties = {_: null};
    }

    const body = JSON.stringify({
      id: itemKey,
      quantity: Number(quantity),
      properties: properties
    });

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: body
      });

      if (response.ok) {
        this.refresh();
      } else {
        throw new Error('Gift properties update failed');
      }
    } catch (error) {
      console.error('Error updating gift properties:', error);
    } finally {
      this.container.classList.remove('cart-disabled');
    }
  }
}
window.addEventListener('load', () => {
  if (typeof Cart !== 'undefined') {
    window.cartInstance = new Cart();
  }
});